import { useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";

import { ShaDowBox } from "../../../../../components/boxes";
import { capitalize, getData } from "../../../../../services";
import {
  GraphFooter,
  NoDataCard,
  Progresses,
  complexItems,
  defaultItems,
} from "../../../../../components/parts";

const RISK = {
  LOW: 84,
  MEDIUM: 50,
  HIGH: 16,
};

export const RiskProfile = ({ complex, building }) => {
  const [buildingRisk, setBuildingRisk] = useState();
  const [points, setPoints] = useState([]);

  const title = building?.id ? "Building's Risk Profile" : "Complex Risk Profile";

  const footerNames = building?.id
    ? ["In this building", "Avg. portfolio", "Avg. Industry"]
    : ["In this complex", "Avg. portfolio", "Avg. Industry"];

  useEffect(() => {
    const url = building?.id
      ? `/praas/v2/buildings/${building.id}/tenants/risk/`
      : `/praas/v2/complexes/${complex.id}/tenants/risk/`;

    getData(url, (data) => {
      if (data.building) {
        setBuildingRisk(data.building);

        const rawPoints = [
          {
            left: RISK[data.portfolio],
            type: "portfolio",
          },
        ];

        if (data.industry) {
          let industryRisk = RISK[data.industry];
          if (data.portfolio === data.industry) {
            rawPoints[0].left -= 5;
            industryRisk += 5;
          }
          rawPoints.push({
            left: industryRisk,
            type: "industry",
          });
        }

        setPoints(rawPoints);
      }
    });

    return () => {
      setBuildingRisk();
      setPoints([]);
    };
  }, [building?.id, complex?.id]);

  return (
    <ShaDowBox style={{ marginTop: 28 }}>
      {buildingRisk ? (
        <Box style={{ padding: 24 }}>
          <Typography variant="h4">{title}</Typography>
          <Box style={{ marginTop: 20 }}>
            <Progresses
              steps={[0, 2, 4]}
              progressBoxStyle={{
                minHeight: 160,
              }}
              mainPointLeft={RISK[buildingRisk]}
              insideText={`${capitalize(buildingRisk)} Risk`}
              points={points}
            />
          </Box>
          <GraphFooter items={building?.id ? defaultItems : complexItems} />
        </Box>
      ) : (
        <NoDataCard title={title} footerNames={footerNames} />
      )}
    </ShaDowBox>
  );
};
